<!--
  CustomerSearchFilter is a reusable component that is used to search for customers.
  It reads/writes from the `search` URL query param.
-->
<script>
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { iIcon } from '@inscribe/signal';

export default {
  components: {
    iIcon,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
      options: [{ label: 'True' }],
    };
  },
  computed: {
    value() {
      return decodeURIComponent(this.params.search || '');
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  beforeDestroy() {
    // Cleanup: Clear the debounce timer to avoid memory leaks
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  },
  methods: {
    debounceInput(value) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      this.debounceTimeout = setTimeout(() => {
        this.onInputChanged(value);
      }, 400);
    },
    onInputChanged(value) {
      if (value === '') {
        value = undefined;
      } else {
        value = encodeURIComponent(value);
      }
      // Note: the 'status' param is cleared when the search input is changed
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          page: 1,
          search: value,
          status: undefined,
        },
      });
    },
    clearSearch() {
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          search: undefined,
        },
      });
    },
  },
};
</script>

<template>
  <div class="i-mt-12 i-mb-lg i-radius-lg">
    <div class="i-form-input-group">
      <div class="input-action float-left">
        <i-icon symbol="small-search" :size="16" />
      </div>

      <b-form-input
        id="customerSearchInput"
        :value="value"
        data-testid="customer-search-input"
        name="customerSearchInput"
        placeholder="Search customers and documents"
        class="i-form-input has-start-icon"
        @input="debounceInput($event)"
      ></b-form-input>

      <button v-if="value" class="input-action" @click="clearSearch()">
        <i-icon symbol="small-delete" :size="20" />
      </button>
    </div>
  </div>
</template>
